import React from 'react';
import styles from './styles/layout.module.scss';
import NewSidebar from './NewSidebar';
import Header from './Header';

function Layout({ children, user, fi }) {
    return (
        <div className={styles.layout}>
            <Header user={user} />
            <div className={styles.contentWrapper}>
                <NewSidebar user={user} fi={fi} />
                <div className={styles.card}>
                    <div className={styles.children}>{children}</div>
                </div>
            </div>
        </div>
    );
}

export default Layout;
